const __WEBPACK_NAMESPACE_OBJECT__ = require("dropzone/dist/dropzone.css");